<mat-card class="cardWithShadow dashboard-card">
  <mat-card-content class="dashboard-card-content">
    <mat-card-title class="dashboard-card-title">
      {{ 'dashboard.case_overview' | translate }}
    </mat-card-title>
    <app-case-overview-chart
      [filedCasesAmount]="kpi().filedCasesAmount"
      [filedCasesTotal]="kpi().filedCasesTotal"
      [cashReimbursementTotal]="kpi().cashReimbursementTotal"
      [inventoryReimbursementTotal]="kpi().inventoryReimbursementTotal"
      [cashReimbursementAmount]="kpi().cashReimbursementAmount"
      [inventoryReimbursementAmount]="kpi().inventoryReimbursementAmount"
      (viewCases)="onViewCases()" />
  </mat-card-content>
</mat-card>
